module.exports = __webpack_public_path__ + "static/media/CommunitMembersPanel.2f14a047.png";